import { axiosConfig } from 'config/application/axios';
import appSettings from 'config/application/app-settings';
import parseUrl from 'utils/parseUrl';
import { init as initRecaptcha } from 'config/application/recaptcha';

export default function boot({ getSettings, appSettings: externalAppSettings } = {}) {
  const publicPath = __webpack_public_path__; // eslint-disable-line

  // TODO тут можно переписать лучше
  // Если на своих стендах, загрузить app-settings.json
  if (getSettings && !externalAppSettings) {
    return axiosConfig
      .getAxiosInstance()
      .get(parseUrl(`${publicPath}app-settings.json`))
      .then(res => {
        const data = res.data;
        Object.keys(data).forEach(key => {
          appSettings[key] = data[key];
        });
      })
      .then(() => {
        axiosConfig.init();
        initRecaptcha();
      });
  }

  if (externalAppSettings) {
    Object.keys(externalAppSettings).forEach(key => {
      appSettings[key] = externalAppSettings[key];
    });
  }

  axiosConfig.init();
  initRecaptcha();

  return undefined;
}
